import { useParams } from 'react-router-dom';
import { useGetSkill } from '@/hooks';
import { buildSkillsPath } from '@/pages/skills/skillsScope';
import type { SkillsScope } from '@/pages/skills/skillsScope';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { SkillCrumbProps } from './types';

const SkillCrumb = ({ param, isCurrentPage = false }: SkillCrumbProps) => {
    const params = useParams();
    const skillId = params[param];
    const agentId = params.agentId;

    const scope: SkillsScope = agentId
        ? {
              kind: 'organization',
              organizationId: agentId,
              basePath: `/agents/${agentId}/skills`,
          }
        : {
              kind: 'platform',
              basePath: '/admin/skills',
          };

    const { skill, isLoadingSkill } = useGetSkill({
        skillId: skillId || '',
        enabled: Boolean(skillId),
    });

    const label = isLoadingSkill ? '...' : skill?.name || `Skill ${skillId?.slice(0, 8)}...`;

    const href = buildSkillsPath({
        scope,
        skillId: skillId || null,
        fileId: null,
        versionId: null,
    });

    return (
        <EntityBreadcrumb
            label={label}
            entityId={skillId || ''}
            entityType="Skill"
            href={href}
            isCurrentPage={isCurrentPage}
            isLoading={isLoadingSkill}
        />
    );
};

export default SkillCrumb;
